import Skeleton from "./Skeleton";

// Props interface for TableSkeleton
interface TableSkeletonProps {
  rows?: number;
  columns?: number;
  className?: string;
  showHeader?: boolean;
}

// TableSkeleton Component - Loading placeholder for tables
const TableSkeleton: React.FC<TableSkeletonProps> = ({
  rows = 5,
  columns = 6,
  className = "",
  showHeader = true,
}) => {
  return (
    <div className={`w-full ${className}`}>
      <div className="overflow-x-auto rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
        <table className="min-w-full">
          {showHeader && (
            <thead>
              <tr className="border-b border-gray-200 dark:border-gray-800">
                {Array.from({ length: columns }).map((_, colIndex) => (
                  <th
                    key={colIndex}
                    className="px-4 py-4 text-left sm:px-6"
                  >
                    <Skeleton height={16} width={colIndex === 0 ? "60%" : "80%"} />
                  </th>
                ))}
              </tr>
            </thead>
          )}
          <tbody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <tr
                key={rowIndex}
                className="border-b border-gray-200 last:border-0 dark:border-gray-800"
              >
                {Array.from({ length: columns }).map((_, colIndex) => (
                  <td key={colIndex} className="px-4 py-4 sm:px-6">
                    <Skeleton
                      height={14}
                      width={
                        colIndex === 0
                          ? "70%"
                          : colIndex === columns - 1
                          ? "50%"
                          : "85%"
                      }
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableSkeleton;
